import React from 'react';
import { Link } from 'react-router-dom';

interface SharedFooterProps {
  compact?: boolean;
}

const SharedFooter: React.FC<SharedFooterProps> = ({ compact = false }) => {
  return (
    <footer className="border-t border-slate-200/70 bg-white/75 backdrop-blur">
      <div className={`mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 ${compact ? 'py-6' : 'py-8'}`}>
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <p className="text-sm font-semibold tracking-[0.02em] text-slate-900">LocalAlly</p>
            <p className="mt-1 text-sm text-slate-500">
              Local learning, trusted discovery, modern education flow.
            </p>
          </div>
          <nav className="flex flex-wrap gap-4 text-sm text-slate-600" aria-label="Footer">
            <Link to="/education" className="transition hover:text-slate-900">
              Education
            </Link>
            <Link to="/education/tutors" className="transition hover:text-slate-900">
              Tutors
            </Link>
            <Link to="/education/classes" className="transition hover:text-slate-900">
              Classes
            </Link>
            <Link to="/education/competitive-exams" className="transition hover:text-slate-900">
              Competitive Exams
            </Link>
            <Link to="/books" className="transition hover:text-slate-900">
              Books
            </Link>
            <Link to="/book-shops" className="transition hover:text-slate-900">
              Book Shops
            </Link>
            <Link to="/scholarship" className="transition hover:text-slate-900">
              Scholarship
            </Link>
            <Link to="/about" className="transition hover:text-slate-900">
              About Us
            </Link>
            <Link to="/contact" className="transition hover:text-slate-900">
              Contact Us
            </Link>
            <Link to="/feedback" className="transition hover:text-slate-900">
              Feedback
            </Link>
            <Link to="/terms-and-conditions" className="transition hover:text-slate-900">
              Terms
            </Link>
            <Link to="/privacy-policy" className="transition hover:text-slate-900">
              Privacy
            </Link>
          </nav>
        </div>
        <p className="mt-6 text-sm text-slate-400">
          &copy; {new Date().getFullYear()} LocalAlly. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default SharedFooter;
